import { Component } from 'react';
import { number, func, bool } from 'prop-types';

class Pagination extends Component {

  static propTypes = {
    currentPage           : number,
    disableInitialCallback: bool,
    enableKeysNavigation  : bool,
    onPageChange          : func,
    totalItems            : number.isRequired,
    pageSize              : number,
    vertical              : bool,
  };

  static defaultProps = {
    pageSize              : 1,
    disableInitialCallback: false,
    enableKeysNavigation  : true,
  };

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if(nextProps.currentPage && nextProps.currentPage !== prevState.currentPage) {
      return {
        currentPage: nextProps.currentPage,
        lastPage: prevState.currentPage - 1,
      };
    }

    return null;
  }

  state = {
    currentPage: this.props.currentPage || 1,
    lastPage: null
  };

  totalPages = Math.ceil(this.props.totalItems / this.props.pageSize);
  totalDisplayItems = 0;

  componentDidMount = () => {
    const { currentPage, disableInitialCallback } = this.props;

    if (typeof(currentPage) !== 'undefined' && !disableInitialCallback) {
      this.callCallback(currentPage);
    }
  }

  handlePreviousPage = e => {
    const { currentPage } = this.state;

    this.selectPage(currentPage === 1 ? this.totalDisplayItems : currentPage - 1, e);
  };

  handleNextPage = e => {
    const { currentPage }  = this.state;

    this.selectPage(currentPage != this.totalDisplayItems ? currentPage + 1 : 1, e);
  };

  selectPage = (page, e) => {
    if(e) { e.preventDefault(); }
    const { currentPage } = this.state;
    const lastPage = currentPage - 1;

    this.setState({
      currentPage: page,
      lastPage: lastPage
    });

    this.callCallback(page, lastPage);
  };

  callCallback = (currentPageItem, lastPage) => {
    if (typeof(this.props.onPageChange) !== 'undefined') {
      this.props.onPageChange({
        currentPage: currentPageItem,
        lastPage: lastPage
      });
    }
  };

  onKeyPressed = e => {
    const { vertical, enableKeysNavigation } = this.props;

    if (!enableKeysNavigation) { return; }

    const key = e.key;
    let action = null;

    if (vertical && (key === 'ArrowUp' || key === 'ArrowDown')) {
      action = key === 'ArrowUp'
        ? this.handlePreviousPage
        : this.handleNextPage;

    } else if (!vertical && (key === 'ArrowLeft' || key === 'ArrowRight')) {
      action = key === 'ArrowLeft'
        ? this.handlePreviousPage
        : this.handleNextPage;
    }

    if (action) { return action(e); }
  }
}

Pagination.displayName = 'Pagination';

export default Pagination;



// WEBPACK FOOTER //
// ./src/uis/elements/Pagination/Pagination.js